import { setAlertModal, setLoading } from "./app";
import axiosInstance from "../../utilities/interceptorUtilities";
import {
  formSubmissionError,
  policiesFetchError,
  formStateError,
  formCountyError,
} from "../../constants/messages";
import {
  liabilityTypes,
  propertyTypes,
  states,
} from "../../constants/data";
import { renameFile } from "../../utilities/appUtilities";
import {
  formatTime,
  formatDate,
  formatDateSQL,
} from "../../utilities/formatUtilities";
import { isMomentObject } from "../../utilities/dateUtilities";
import { replaceTriggers } from "../../utilities/firewallUtilities";
import { COMMERCIAL, PERSONAL, formTypes } from "../../constants/keys";

export const SEND_AUTO_FORM = "SEND_AUTO_FORM";
export const SEND_PROPERTY_FORM = "SEND_PROPERTY_FORM";
export const SEND_AUTO_GLASS_FORM = "SEND_AUTO_GLASS_FORM";
export const SEND_WC_FORM = "SEND_WC_FORM";
export const GET_STATES = "GET_STATES";
export const GET_COUNTIES = "GET_COUNTIES";
export const GET_POLICIES = "GET_POLICIES";
export const SET_PERSONAL_POLICIES = "SET_PERSONAL_POLICIES";
export const SET_COMMERCIAL_POLICIES = "SET_COMMERCIAL_POLICIES";
export const CLEAR_FORM = "CLEAR_FORM";
export const GET_WC_PARTS = "GET_WC_PARTS";
export const GET_WC_CAUSES = "GET_WC_CAUSES";
export const GET_WC_NATURES = "GET_WC_NATURES";
export const GET_LOSS_CAUSES = "GET_LOSS_CAUSES";
export const SET_WC_ERROR = "SET_WC_ERROR";
export const SET_WC_PDF = "SET_WC_PDF";
export const SET_ATTACHMENT_FAILURES = "SET_ATTACHMENT_FAILURES";
export const POLICY_SEARCH_RETRIEVE = "POLICY_SEARCH_RETRIEVE";
export const GET_DRIVERS = "GET_DRIVERS";
export const SET_FORM_TYPE = "SET_FORM_TYPE";

export const resetClearForm = () => {
  return async (dispatch) => {
    dispatch({ type: CLEAR_FORM, clear: { auto: false, property: false } });
  };
};

export const sendAutoForm = (
  formData,
  documents,
  claimType,
  policyType,
  history
) => {
  return async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));

      const form = new FormData();
      const userInfo = getState().user.userInfo;
      const agentInfo = getState().user.agentInfo;
      const info = userInfo ? userInfo : agentInfo;

      const url =
        process.env.REACT_APP_API_URL +
        "/api/ReportClaim/GeneratePdfSendFaxAuto";
        formData.claimId = 0;
        formData.emailId = info.UserEmailId ? info.UserEmailId : null;
        formData.accountId = info.AccountId ? Number(info.AccountId) : 0;
        formData.userId = userInfo ? String(userInfo.UserId) : agentInfo?.userId
        formData.claimType = claimType;
        formData.policyType = policyType;
        formData.propertyParty = 0;
        formData.sessionId = info.SessionId ? info.SessionId : "";
        formData.userBeingImpersonated = info.IsImpersonate ? info.IsImpersonate : "";
        formData.agentCode = agentInfo ? agentInfo.agentCode : "";
        formData.isFromAgent = agentInfo ? true : false;
        formData.whereDate = `${formatDate(formData.whereDate)} ${formatTime(
          formData.whereDate
        )}`;
        formData.otherVehicleOwnerInsuranceName = "";
      let formString = JSON.stringify(formData);

      formString = replaceTriggers(formString);
      form.append("form", formString);

      documents.forEach((file) => {
        let fileName = file.name;
        const newFile = renameFile(file, fileName.replace("'", ""));
        form.append(newFile.name, newFile);
      });

      const response = await axiosInstance.post(url, form, {
        withCredentials: true,
      });

      if (response.status !== 200) {
        throw new Error(`${response.status} ${response.statusText}`);
      }

      const data = await response.data;
      const referenceNumber = data?.ClaimRefNumber;
      const attachmentFailures = data?.AttachmentFailures;

      dispatch({ type: CLEAR_FORM, clear: { auto: true, property: false } });
      dispatch(clearPolicyAssets());
      dispatch({ type: SEND_PROPERTY_FORM, referenceNumber });
      dispatch(setLoading(false));
      dispatch(setAttachmentFailures(attachmentFailures));
      if (referenceNumber) {
        agentInfo ? history.push(`/claimsubmitted-a/${referenceNumber}`) : history.push(`/claimsubmitted/${referenceNumber}`);
      } else {
        agentInfo ? history.push("/claimsubmitted-a/") : history.push("/claimsubmitted/");
      }
    } catch (err) {
      console.log(`Error: ${err.message}`);
      dispatch(setLoading(false));
      dispatch(setAlertModal(true, "error", formSubmissionError));
      setTimeout(() => {
        dispatch(setAlertModal(false, ""));
      }, 5000);
    }
  };
};

export const sendPropertyForm = (
  formData,
  documents,
  claimType,
  policyType,
  history
) => {
  return async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));

      const form = new FormData();
      const userInfo = getState().user.userInfo;
      const agentInfo = getState().user.agentInfo;
      const info = userInfo ? userInfo : agentInfo;

      const url =
        process.env.REACT_APP_API_URL +
        "/api/ReportClaim/GeneratePdfSendFaxHome";

      formData.claimId = 0;
      formData.emailId = info.UserEmailId || null;
      formData.accountId = info.AccountId ? Number(info.AccountId) : 0;
      formData.userId = userInfo ? String(userInfo.UserId) : agentInfo?.userId;
      formData.claimType = claimType;
      formData.policyType = policyType;
      formData.propertyParty = 0;
      formData.sessionId = info.SessionId;
      formData.userBeingImpersonated = info.IsImpersonate ? info.IsImpersonate : "";
      formData.whereDate = `${formatDate(formData.whereDate)} ${formatTime(
        formData.whereDate
      )}`;
      formData.agentCode = agentInfo ? agentInfo.agentCode : "";
      formData.isFromAgent = agentInfo ? true : false;

      let formString = JSON.stringify(formData);
      formString = replaceTriggers(formString);
      form.append("form", formString);

      documents.forEach((file) => {
        form.append(file.name, file);
      });

      const response = await axiosInstance.post(url, form, {
        withCredentials: true,
      });

      if (response.status !== 200) {
        throw new Error(`${response.status} ${response.statusText}`);
      }

      const data = await response.data;
      const referenceNumber = data?.ClaimRefNumber;
      const attachmentFailures = data?.AttachmentFailures;
      dispatch({ type: CLEAR_FORM, clear: { auto: false, property: true } });
      dispatch({ type: SEND_AUTO_FORM, referenceNumber });
      dispatch(setLoading(false));
      dispatch(setAttachmentFailures(attachmentFailures));

      if (referenceNumber) {
        agentInfo ? history.push(`/claimsubmitted-a/${referenceNumber}`) : history.push(`/claimsubmitted/${referenceNumber}`);
      } else {
        agentInfo ? history.push("/claimsubmitted-a/") : history.push("/claimsubmitted/");
      }
    } catch (err) {
      console.log(`Error: ${err.message}`);
      dispatch(setLoading(false));
      dispatch(setAlertModal(true, "error", formSubmissionError));
      setTimeout(() => {
        dispatch(setAlertModal(false, ""));
      }, 5000);
    }
  };
};

export const sendAutoGlassForm = (policyNumber) => {
  return async (dispatch, getState) => {
    try {
      const url =
        process.env.REACT_APP_API_URL +
        "/api/Claims/GetAutoGlassPolicySignature";
      let body = { PolicyNumber: policyNumber.split("/")[0] };

      const response = await axiosInstance.post(url, body, {
        headers: { "content-type": "application/json" },
        withCredentials: true,
      });

      const autoGlassPolicySignature = await response.data;

      let form = window.document.createElement("form");
      form.setAttribute("id", "safeliteForm");
      form.setAttribute("method", "post");
      form.setAttribute("action", process.env.REACT_APP_SAFELITE_URL);
      form.setAttribute("target", "_blank");
      window.document.body.appendChild(form);

      var sPolicyNumber = window.document.createElement("input");
      sPolicyNumber.setAttribute("type", "hidden");
      sPolicyNumber.setAttribute("name", "PolicyNumber");
      sPolicyNumber.setAttribute(
        "value",
        autoGlassPolicySignature.PolicyNumber
      );
      window.document.getElementById("safeliteForm").appendChild(sPolicyNumber);

      var sToken = window.document.createElement("input");
      sToken.setAttribute("type", "hidden");
      sToken.setAttribute("name", "Token");
      sToken.setAttribute("value", autoGlassPolicySignature.Token);
      window.document.getElementById("safeliteForm").appendChild(sToken);

      var sSignature = window.document.createElement("input");
      sSignature.setAttribute("type", "hidden");
      sSignature.setAttribute("name", "Signature");
      sSignature.setAttribute("value", autoGlassPolicySignature.Signature);
      window.document.getElementById("safeliteForm").appendChild(sSignature);

      form.submit();
      window.document.body.removeChild(form);
    } catch (err) {
      dispatch(setAlertModal(true, "error", formSubmissionError));
      setTimeout(() => {
        dispatch(setAlertModal(false, ""));
      }, 5000);
    }
  };
};

export const getStates = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: GET_STATES, states: states });
    } catch (err) {
      dispatch(setAlertModal(true, "error", formStateError));
      setTimeout(() => {
        dispatch(setAlertModal(false, ""));
      }, 5000);
    }
  };
};

export const getCounties = (state) => {
  return async (dispatch) => {
    try {
      const url = process.env.REACT_APP_API_URL + "/api/Claims/GetCounties";
      let body = { state };

      const response = await axiosInstance.post(url, body, {
        headers: { "content-type": "application/json" },
        withCredentials: true,
      });

      dispatch({ type: GET_COUNTIES, counties: response.data.Counties });
    } catch (err) {
      dispatch(setAlertModal(true, "error", formCountyError));
      setTimeout(() => {
        dispatch(setAlertModal(false, ""));
      }, 5000);
    }
  };
};

export const getAllPolicies = () => {
  return async (dispatch, getState) => {
    try {
      let appState = null;
      if (sessionStorage.getItem("appState")) {
        appState = JSON.parse(sessionStorage.getItem("appState"));
      }

      dispatch(setLoading(true));

      const policyType = getState().app.policyType.active;
      const accountIds = {
        PERS: getState().app.policyType.personal,
        COM: getState().app.policyType.commercial,
      };
      const accountId =
        policyType === PERSONAL ? accountIds.PERS : accountIds.COM;

      const url = process.env.REACT_APP_API_URL + "/api/Policy/ViewAllPolicies";

      if (policyType === PERSONAL) {
        const autoPolicies = appState
          ? appState.forms.autoPolicies
          : await policyFetch(url, "AUTO", policyType, accountIds, accountId);
        const homePolicies = appState
          ? appState.forms.homePolicies
          :  await policyFetch(url, "HOME", policyType, accountIds, accountId);
        dispatch({
          type: SET_PERSONAL_POLICIES,
          auto: autoPolicies,
          home: homePolicies,
        });
      } else if (policyType === COMMERCIAL) {
        const vehiclePolicies = appState
        ? appState.forms.vehiclePolicies
        : await policyFetch(url, "AUTO", policyType, accountIds, accountId);
        const propertyPolicies = appState
          ? appState.forms.propertyPolicies
          : await policyFetch(
              url,
              propertyTypes,
              policyType,
              accountIds,
              accountId
            );
        const liabilityPolicies = appState
          ? appState.forms.liabilityPolicies
          : await policyFetch(
              url,
              liabilityTypes,
              policyType,
              accountIds,
              accountId
            );
        const wcPolicies = appState
          ? appState.forms.wcPolicies
          : await policyFetch(url, "WC", policyType, accountIds, accountId);
        dispatch({
          type: SET_COMMERCIAL_POLICIES,
          vehicle: vehiclePolicies,
          property: propertyPolicies,
          liability: liabilityPolicies,
          wc: wcPolicies,
        });
      }

      dispatch(setLoading(false));
    } catch (err) {
      dispatch(setAlertModal(true, "error", err.message));
      setTimeout(() => {
        dispatch(setAlertModal(false, ""));
      }, 5000);
    }
  };
};

export const setFormType = (formType) => {
  return (dispatch) => {
    dispatch({ type: SET_FORM_TYPE, formType });
  };
};

const policyFetch = async (
  url,
  claimType,
  policyType,
  accountIds,
  accountId
) => {
  let policyArray = [];
  const body = { accountId };
  if (typeof claimType === "string") {
    body.claimType = claimType;
  }
  const response = await axiosInstance.post(url, body, {
    headers: { "content-type": "application/json" },
    withCredentials: true,
  });
  const responsePolicies = await response.data.PolicyDetail;
  if (responsePolicies) {
    await responsePolicies.forEach((policy) =>
      policyArray.push({
        policyNumber: policy.PolicyNumber,
        policyEffectiveDate: policy.PolicyEffectiveDate,
        policyType: policy.PolicyType,
      })
    );
    policyArray.sort((a, b) => a.policyNumber - b.policyNumber);

    if (claimType?.length > 0) {
      policyArray = policyArray.filter((policy) =>
        claimType.includes(policy.policyType.trim())
      );
    }
  }
  return policyArray;
};

export const getPolicies = (claimType) => {
  return async (dispatch, getState) => {
    try {
      const policyType = getState().app.policyType.active;
      const accountIds = {
        PERS: getState().app.policyType.personal,
        COM: getState().app.policyType.commercial,
      };
      const accountId =
        policyType === PERSONAL ? accountIds.PERS : accountIds.COM;

      const url = process.env.REACT_APP_API_URL + "/api/Policy/ViewAllPolicies";
      const body = { accountId, claimType };

      const response = await axiosInstance.post(url, body, {
        headers: { "content-type": "application/json" },
        withCredentials: true,
      });

      const responsePolicies = await response.data.PolicyDetail;

      if (!responsePolicies) {
        return;
      }

      let policies = [];
      await responsePolicies.forEach((policy) =>
        policies.push({
          policyNumber: policy.PolicyNumber,
          policyEffectiveDate: policy.PolicyEffectiveDate,
          policyType: policy.PolicyType,
        })
      );

      if (claimType == null) {
        policies = policies.filter((policy) =>
          propertyTypes.includes(policy.policyType.trim())
        );
      }

      policies.sort((a, b) => a.policyNumber - b.policyNumber);

      dispatch({ type: GET_POLICIES, policies });
    } catch (err) {
      dispatch(setAlertModal(true, "error", policiesFetchError));
      setTimeout(() => {
        dispatch(setAlertModal(false, ""));
      }, 5000);
    }
  };
};

export const clearPolicyAssets = () => {
  return async (dispatch, getState) => {
    dispatch({ type: POLICY_SEARCH_RETRIEVE, policyRetrievalData: null });
    dispatch({ type: GET_DRIVERS, drivers: null });
  };
};

export const getWCParts = () => {
  return async (dispatch) => {
    try {
      const url =
        process.env.REACT_APP_API_URL + "/api/Claims/GetWCInjuryParts";

      const response = await axiosInstance.post(url, "", {
        headers: { "content-type": "application/json" },
        withCredentials: true,
      });

      const parts = response.data;
      dispatch({ type: GET_WC_PARTS, parts });
    } catch (err) {
      dispatch({ type: SET_WC_ERROR, error: true });
      dispatch(setLoading(false));
    }
  };
};

export const getWCCauses = () => {
  return async (dispatch) => {
    try {
      const url =
        process.env.REACT_APP_API_URL + "/api/Claims/GetWCInjuryCauses";

      const response = await axiosInstance.post(url, "", {
        headers: { "content-type": "application/json" },
        withCredentials: true,
      });

      const causes = response.data;
      dispatch({ type: GET_WC_CAUSES, causes });
    } catch (err) {
      dispatch({ type: SET_WC_ERROR, error: true });
      dispatch(setLoading(false));
    }
  };
};

export const getWCNatures = () => {
  return async (dispatch) => {
    try {
      const url =
        process.env.REACT_APP_API_URL + "/api/Claims/GetWCInjuryNatures";

      const response = await axiosInstance.post(url, "", {
        headers: { "content-type": "application/json" },
        withCredentials: true,
      });

      const natures = response.data;
      dispatch({ type: GET_WC_NATURES, natures });
    } catch (err) {
      dispatch({ type: SET_WC_ERROR, error: true });
      dispatch(setLoading(false));
    }
  };
};

export const getLossCauses = () => {
  return async (dispatch) => {
    try {
      const url = process.env.REACT_APP_API_URL + "/api/Claims/GetLossCauses";

      const response = await axiosInstance.post(url, "", {
        headers: { "content-type": "application/json" },
        withCredentials: true,
      });

      let lossCauses = response.data;
      const otherIndex = lossCauses.findIndex(
        (cause) => cause.FullText === "All Other"
      );

      if (otherIndex !== -1) {
        const other = lossCauses[otherIndex];
        lossCauses.splice(otherIndex, 1);
        lossCauses.push(other);
      } //move "All Other" to the end of the list

      dispatch({ type: GET_LOSS_CAUSES, lossCauses });
    } catch (err) {}
  };
};

export const sendWCForm = (formData, documents, history, policyNumber) => {
  return async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      const form = new FormData();
      const userInfo = getState().user.userInfo;
      const agentInfo = getState().user.agentInfo;
      const info = userInfo ? userInfo : agentInfo;

      const url =
        process.env.REACT_APP_API_URL + "/api/ReportClaim/GeneratePdfSendFaxWC";

      formData.SessionId = String(info.SessionId);
      formData.UserBeingImpersonated = info.IsImpersonate
        ? info.IsImpersonate
        : "";
      formData.policyNumber = policyNumber;
      formData.isFromAgent = agentInfo ? true : false;
      formData.agentCode = agentInfo ? agentInfo.agentCode : "";
      formData.emailId = info.UserEmailId || null;
      formData.accountId = info.AccountId;
      formData.claimType = "Workers Comp";
      formData.lobCode = "WC";
      formData.incidentDate = `${formatDate(
        formData.incidentDate
      )} ${formatTime(formData.incidentDate)}`;
      if (isMomentObject(formData.employerNotifiedDate)) {
        formData.employerNotifiedDate = `${formatDate(
          formData.employerNotifiedDate
        )} ${formatTime(formData.employerNotifiedDate)}`;
      }
      const formatIfDate = (date) =>
        isMomentObject(date) ? `${formatDate(date)}` : date;
      formData.dateOfDeath = formatIfDate(formData.dateOfDeath);
      formData.lastDateWorked = formatIfDate(formData.lastDateWorked);
      formData.jobHireDate = formatIfDate(formData.jobHireDate);
      formData.jobTerminationDate = formatIfDate(formData.jobTerminationDate);
      formData.returnedDate = formatIfDate(formData.returnedDate);
      formData.claimantDateOfBirth = isMomentObject(
        formData.claimantDateOfBirth
      )
        ? formatDateSQL(formData.claimantDateOfBirth)
        : formData.claimantDateOfBirth;

      let formString = replaceTriggers(JSON.stringify(formData));
      form.append("form", formString);

      documents.forEach((file) => {
        form.append(file.name, file);
      });

      const response = await axiosInstance.post(url, form, {
        withCredentials: true,
      });

      if (response.status !== 200) {
        throw new Error(`${response.status} ${response.statusText}`);
      }

      const data = await response.data;
      const referenceNumber = data?.ClaimRefNumber;
      const pdf = data?.Pdf;
      const attachmentFailures = data?.AttachmentFailures;

      dispatch({ type: SEND_WC_FORM, referenceNumber });
      dispatch({ type: SET_WC_PDF, pdf });
      dispatch(setLoading(false));
      dispatch(setAttachmentFailures(attachmentFailures));
      if (referenceNumber) {
        agentInfo ? history.push(`/claimsubmitted-a/${referenceNumber}`) : history.push(`/claimsubmitted/${referenceNumber}`);
      } else {
        agentInfo ? history.push("/claimsubmitted-a/") : history.push("/claimsubmitted/");
      }
    } catch (err) {
      dispatch(setLoading(false));
      dispatch(setAlertModal(true, "error", formSubmissionError));
      setTimeout(() => {
        dispatch(setAlertModal(false, ""));
      }, 5000);
    }
  };
};

const setAttachmentFailures = (attachmentFailures) => {
  return (dispatch) => {
    dispatch({ type: SET_ATTACHMENT_FAILURES, attachmentFailures });
  };
};

export const clearAttachmentFailures = () => {
  return (dispatch) => {
    dispatch({ type: SET_ATTACHMENT_FAILURES, attachmentFailures: [] });
  };
};

export const clearPdf = () => {
  return (dispatch) => {
    dispatch({ type: SET_WC_PDF, pdf: "" });
  };
};

//cvdm policy search
export const policySearchRetrieve = (lossDate, policyNumber) => {
  return async (dispatch, getState) => {
    try {
      const url =
        process.env.REACT_APP_API_URL + "/api/Claims/PolicySearchRetrieve";
      let body = { lossDate, policyNumber };
      if (getState().user.userInfo) {
        body.AccountId = getState().user.userInfo.AccountId;
      } else {
        body.AgentCode = getState().user.agentInfo.agentCode;
      } //for boundary check

      const response = await axiosInstance.post(url, body, {
        headers: { "content-type": "application/json" },
        withCredentials: true,
      });

      if (response.data) {
        const data = JSON.parse(response.data);
        let sortedLocations = data.locations?.sort(
          (a, b) => a.locationNumber - b.locationNumber
        );
        if (!sortedLocations) {
          sortedLocations = [];
        }
        let filteredVehicles = data.vehicleList?.filter(
          (vehicle) =>
            vehicle.vehicleIdentificationNumber ||
            (vehicle.manufacturer && vehicle.model)
        );
        const policyRetrievalData = {
          ...data,
          locations: sortedLocations,
          vehicleList: filteredVehicles,
        };
        let drivers = policyRetrievalData.contacts.filter(
          (contact) =>
            (contact.contactRole === "insured" ||
              contact.contactRole === "coveredparty") &&
            contact.lastName
        );
        dispatch({
          type: POLICY_SEARCH_RETRIEVE,
          policyRetrievalData,
        });
        dispatch({ type: GET_DRIVERS, drivers });
        dispatch(setLoading(false));
      } else {
        throw new Error();
      }
    } catch (err) {
      dispatch({
        type: POLICY_SEARCH_RETRIEVE,
        policyRetrievalData: { locations: [], vehicleList: [] },
      });
      dispatch({ type: GET_DRIVERS, drivers: [] });
      dispatch(setLoading(false));
    } //to show retrieval finished
  };
};
